/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import appConfig from '@nerdwallet/app-config';
import nwAnalytics from '@nerdwallet/analytics';
import {
  Impression,
  ImpressionContext,
} from '@nerdwallet/analytics/react/impression';
import { Box } from '@nerdwallet/currency';

import useAnalytics from '~/client/lib/segment/useAnalytics';
import SegmentImpression from '../../segment-impression';
import TaxAnnouncementBanner from './tax-announcement-banner';

interface Props {
  handleOnClose: () => void;
  campaign: string;
  campaignKey: string;
}

type ActionType = 'close' | 'select';

const AnnouncementBanner: React.FC<Props> = ({
  handleOnClose = () => {},
  campaign,
  campaignKey,
}) => {
  const { trackSegmentTrackEvent } = useAnalytics();
  const [isDesktop, setIsDesktop] = useState<boolean>();
  const [segmentImpressionId] = useState(uuidv4());

  useEffect(() => {
    const userAgent = navigator?.userAgent;

    // No link for mobile
    setIsDesktop(userAgent?.indexOf('Mobi') === -1);
  }, []);

  const handleClickTracking =
    (type: ActionType, impressionId: string, cb = () => {}) =>
    () => {
      const action = type === 'close' ? 'closed' : 'clicked';

      trackSegmentTrackEvent(`${campaign} Banner CTA ${action}`, {
        parent_impression_id: segmentImpressionId,
        section_name: 'desktop_homepage',
      });
      nwAnalytics.track('element_interacted', {
        action: type,
        entity_name: `${campaignKey}_banner_cta_${action}`,
        impression_id: impressionId,
        interaction_type: 'press',
      });

      if (cb) cb();
    };

  return (
    <SegmentImpression
      eventName={`${campaign} Banner Viewed`}
      eventProps={{
        impression_id: segmentImpressionId,
        section_name: isDesktop ? 'desktop_homepage' : 'mobile_web_homepage',
      }}
    >
      <Impression
        eventType="element_impression"
        entityName={`${campaignKey}_announcement_banner`}
        payload={{
          section_name: isDesktop ? 'desktop_homepage' : 'mobile_web_homepage',
        }}
      >
        <ImpressionContext.Consumer>
          {({ impressionId }) => (
            <Box>
              <TaxAnnouncementBanner
                onCloseButtonClick={handleClickTracking(
                  'close',
                  impressionId,
                  handleOnClose
                )}
                onLinkClick={handleClickTracking('select', impressionId, () => {
                  window.location.href = `${appConfig?.SITE_BASE_URL}/p/file-taxes-online`;
                })}
              />
            </Box>
          )}
        </ImpressionContext.Consumer>
      </Impression>
    </SegmentImpression>
  );
};

export default AnnouncementBanner;
/* eslint-enable @typescript-eslint/no-unused-vars */
